"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancelTicketRoute = void 0;
exports.cancelTicketRoute = '/ticket/';
//# sourceMappingURL=cancel.route.js.map